<template>
  <!-- 2024-12-30 가이드: 퍼블 수정 -->
  <template v-if="!isPub()">
    <!-- ■■■ 개발 영역 ■■■ -->
    <div
      :class="[
        'l-wrap',
        {
          'layout-login': ['/', '/paintpro/login'].includes(route.path),
        },
        {
          'layout-member': [
            '/',
            '/paintpro/login',
            '/member',
            '/member/idsrch',
            '/member/pwdsrch',
          ].includes(route.path),
        },
        {
          'layout-main': ['/paintpro/main'].includes(route.path),
        },
        {
          'layout-order': [
          '/paintpro/prodList',
          '/paintpro/myRoom',
          '/paintpro/search',
          ].includes(route.path),
        },
        {
          'layout-error': [
            '/paintpro/error/error404',
            '/paintpro/error/error500',
            '/paintpro/error/systemCheck',
          ].includes(route.path),
        },
      ]"
    >
      <Header />
      <MoHistoryBack :titleName="pageTitle" />
      <main id="container" class="l-container">
        <RouterView />
      </main>
      <Footer
        :nonPartnerShip="
          [
            '/',
            '/paintpro/login',
            '/logout',
            '/member',
            '/member/idsrch',
            '/member/pwdsrch',
          ].includes(route.path)
        "
        :isJoin="
          [
            '/',
            '/paintpro/login',
            '/logout',
            '/member',
            '/member/idsrch',
            '/member/pwdsrch',
          ].includes(route.path)
        "
      />
    </div>
    <!-- D:popup불러오는 위치 -->
    <!-- D: 쿠키팝업 -->
    <CookiePop v-if="data.isCookiePop" />
    <CommonPop
      v-if="data.isCommonPop && ['/paintpro/main'].includes(route.path)"
      :is-pc-no-dimm="true"
    />
    <!-- D: 공통팝업: popup, alert, toast 등... -->
    <!-- //popup -->
  </template>
  <template v-if="isPub()">
    <!-- ■■■ 퍼블 영역 ■■■ -->
    <div
      :class="[
        'l-wrap',
        {
          'layout-login': ['/paintpro_pub/login'].includes(route.path),
        },
        {
          'layout-main': ['/paintpro_pub/main'].includes(route.path),
        },
        {
          'layout-order': ['/paintpro_pub/prodList'].includes(route.path),
        },
        {
          'layout-error': [
            '/error',
            '/paintpro_pub/error/error404',
            '/paintpro_pub/error/error500',
            '/paintpro_pub/error/systemCheck',
          ].includes(route.path),
        },
      ]"
    >
      <div
        _info="HeaderPub"
        v-if="
          ![
            '/',
            '/paintpro_pub/login',
            '/paintpro_pub/error/error404',
            '/paintpro_pub/error/error500',
            '/paintpro_pub/error/systemCheck',
          ].includes(route.path) && ['pc'].includes(checkDeviceType)
        "
      />
      <!-- 
          D: 상세유형페이지에서 MO에서만 MO전용 헤더 노출 할 수 있게 개발 필요
          1. 상세유형 페이지 대상은 아래 if 경로임
         -->
      <div
        _info="MoHistoryBackPub"
        v-if="
          ![
            '/',
            '/paintpro_pub/login',
            '/paintpro_pub/error/error404',
            '/paintpro_pub/error/error500',
            '/paintpro_pub/error/systemCheck',
          ].includes(route.path) &&
          ['mobile', 'tablet'].includes(checkDeviceType)
        "
        :titleName="pageTitle"
      />
      <main id="container" class="l-container">
        <RouterView />
      </main>
      <div
        _info="FooterPub"
        v-if="
          ![
            '/error',
            '/paintpro_pub/error/error404',
            '/paintpro_pub/error/error500',
            '/paintpro_pub/error/systemCheck',
          ].includes(route.path)
        "
      />
    </div>

    <!-- D:popup불러오는 위치 -->
    <!-- D: 쿠키팝업 -->
    <div _info="CookiePopPub" v-if="data.isCookiePop" />
    <div _info="CommonPopPub" v-if="data.isCommonPop" />
    <!-- D: 공통팝업: popup, alert, toast 등... -->
    <!-- //popup -->
  </template>
  <!-- ■■■ 개발/퍼블 영역 ■■■ -->
  <Toast />
  <ConfirmDialog />
  <BaseCmDialog />
  <BaseOrderDialog />
  <BaseProdDialog />
  <BaseDispDialog />
  <AlertDialog />
  <LoadingDialog />
  <ExpPwdChangePop
    v-if="isShowPasswordChangePop"
    @close="() => closePasswordChangePop()"
  />
</template>
<script setup name="App">
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ExpPwdChangePop from "@/components/paintpro/member/expPwdChangePop.vue";
// import * as cmUtil from "@/utils/cmUtil.js";
// import { useAuthStore } from "@/store";
// import Header from "@/components/common/header/Header.vue";
// import Navi from "@/components/common/header/Navi.vue";
// import Header2 from "@/components/common/header/HeaderHidden.vue";
// import Footer from "@/components/common/footer/Footer.vue";

// ■■■ 개발 영역 ■■■
import Header from "@/components/paintpro/layout/header1.vue";
import MoHistoryBack from "@/components/paintpro/layout/moHistoryBack.vue";
import Footer from "@/components/paintpro/layout/footer1.vue";
import CookiePop from "@/components/paintpro/common/cookiePop.vue";
import CommonPop from "@/components/paintpro/common/commonPop.vue";

// ■■■ 퍼블 영역 ■■■
// import HeaderPub from "@/components/paintpro_pub/layout/header1.vue";
// import MoHistoryBackPub from "@/components/paintpro_pub/layout/moHistoryBack.vue";
// import FooterPub from "@/components/paintpro_pub/layout/footer1.vue";
// import CookiePopPub from "@/components/paintpro_pub/common/cookiePop.vue";
// import CommonPopPub from "@/components/paintpro_pub/common/commonPop.vue";

// ■■■ 개발/퍼블 영역 ■■■
import Toast from "@/components/paintpro/common/toast.vue";
import ConfirmDialog from "@/components/paintpro/common/ConfirmDialog.vue";
import AlertDialog from "@/components/paintpro/common/AlertDialog.vue";
import LoadingDialog from "@/components/paintpro/common/LoadingDialog.vue";
import BaseCmDialog from "@/components/paintpro/common/BaseCmDialog.vue";
import BaseOrderDialog from "@/components/paintpro/common/BaseOrderDialog.vue";
import BaseProdDialog from "@/components/paintpro/common/BaseProdDialog.vue";
import BaseDispDialog from "@/components/paintpro/common/BaseDispDialog.vue";

import * as store from "@/store";

import { useCommon } from "@/js/_ui";
import "@/assets/scss/app.scss";

const applicationStore = store.useApplicationStore();

const route = useRoute();
const router = useRouter();
// const authStore = useAuthStore();
const { width } = useCommon();
let pageTitle = ref("");
let checkDeviceType = ref("");

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  isCommonPop: false,
  isCookiePop: false,
});

onMounted(() => {
  // applicationStore.loadUserManuals();
});

const isShowPasswordChangePop = computed(() => {
  return applicationStore.isShowPasswordChangePop;
});

const closePasswordChangePop = () => {
  applicationStore.showPasswordChangePop(false);
};

/***********************
 * computed 모음
 **********************/
// 화면 해상도 체크
checkDeviceType = computed(() => {
  if (width.value <= 768) {
    return "mobile"; // 768 이하를 모바일로 간주
  } else if (width.value <= 1024) {
    return "tablet"; // 768 ~ 1024px을 태블릿으로 간주
  }
  return "pc"; // 그 이상을 PC로 간주
});

// D : 상세유형의 페이지에서 Mo전용 헤더를 노출하기 위해 MO상세유형 path 체크
// const checkMobileHeaderRoute = (paths) => {
//   return computed(() => {
//     // 모바일 체크
//     if (checkDeviceType.value !== "mobile") return false;

//     // 경로 체크
//     if (Array.isArray(paths)) {
//       // 배열인 경우: 하나라도 포함되어 있으면 true
//       return paths.some((path) => route.path.includes(path));
//     } else {
//       // 문자열인 경우: 해당 문자열이 포함되어 있으면 true
//       return route.path.includes(paths);
//     }
//   }).value;
// };

const isPub = () => {
  return route.path.indexOf("/paintpro_pub") > -1 ? true : false;
};

const currentPopCount = computed(() => {
  return applicationStore.popIds.length;
});

// 팝업 여부에 따른 html.popup-open 설정
watch(currentPopCount, (newVal) => {
  // console.log("currentPopCount", currentPopCount.value);
  const htmlEl = document.getElementsByTagName("html")[0];
  if (newVal > 0) {
    if (!htmlEl.classList.contains("popup-open")) {
      htmlEl.classList.add("popup-open");
    }
  } else {
    if (htmlEl.classList.contains("popup-open")) {
      htmlEl.classList.remove("popup-open");
    }
  }
});

/***********************
 * watch 모음
 **********************/
watch(
  () => store.useEventBusStore().isCommonPop,
  (newValue) => {
    data.isCommonPop = newValue;
  }
);

watch(
  () => store.useEventBusStore().isCookiePop,
  (newValue) => {
    data.isCookiePop = newValue;
  }
);

/***********************
 * router.isReady
 **********************/

// D: MO 타이틀 노출을 위한 개발&리팩토링 필요
router.isReady().then(() => {
  // if (["/member"].includes(route.path) || ["/join"].includes(route.path)) {
  //   pageTitle.value = "회원가입";
  // } else if (
  //   [
  //     "/orderList/moListDetail",
  //     "/paintpro/orderList/moListDetail",
  //     "/paintpro_pub/orderList/moListDetail",
  //   ].includes(route.path)
  // ) {
  //   pageTitle.value = "출고현황 상세보기";
  // } else if (["/utility", "/utility", "/utility"].includes(route.path)) {
  //   pageTitle.value = "내정보";
  // } else if (
  //   [
  //     "/quickMenu/rcentlyViewedProd",
  //     "/paintpro/quickMenu/rcentlyViewedProd",
  //     "/paintpro_pub/quickMenu/rcentlyViewedProd",
  //   ].includes(route.path)
  // ) {
  //   pageTitle.value = "최근 본 제품";
  // } else if (
  //   [
  //     "/orderBasket",
  //     "/paintpro/orderBasket",
  //     "/paintpro_pub/orderBasket",
  //   ].includes(route.path)
  // ) {
  //   pageTitle.value = "장바구니";
  // } else if (
  //   [
  //     "/orderOrder",
  //     "/paintpro/orderOrder",
  //     "/paintpro_pub/orderOrder",
  //   ].includes(route.path)
  // ) {
  //   pageTitle.value = "주문서 작성";
  // } else if (
  //   [
  //     "/orderList/detail",
  //     "/paintpro/orderList/detail",
  //     "/paintpro_pub/orderList/detail",
  //   ].includes(route.path)
  // ) {
  //   pageTitle.value = "주문상세";
  // } else if (
  //   ["/search", "/paintpro/search", "/paintpro_pub/search"].includes(route.path)
  // ) {
  //   pageTitle.value = "검색결과";
  // }
});
</script>
<style></style>
